import { AppContextType } from "utils/AppContext";
import { IEnvironment, LOCAL_ENV } from "../types/EnvironmentTypes";

export const isRunningLocally = () => {
  const hostname = new URL(document.location.href).hostname;
  const topDomain = hostname.split(".").pop();
  return topDomain === "localhost" || hostname.startsWith("10.101.");
};

export const isRunningOnProd = () => {
  return document.location.href.includes("admin.prod.tfk.fortisapi.games");
};

export const getBaseURL = (appContext: AppContextType | undefined) =>
  appContext?.selectedEnvironment?.baseURL || "http://localhost:3001/";

export const sortEnvironmentList = (environments: IEnvironment[], minStage: number = 0, maxStage: number = 9) => {
  // this should sort the environment list in the following order:
  // 1. local environment (if running locally)
  // 2. registry environment
  // 3. staging environment
  // 4. default environment
  // 5. pod environments (alphabetically)
  // 6. development environments (alphabetically)
  // 7. the rest

  const envs = [];
  const activeEnvs = environments.filter((env) => {
    if (env.terminationDate !== undefined) return false;
    if (minStage !== undefined && env.stage < minStage) return false;
    if (maxStage !== undefined && env.stage > maxStage) return false;
    return true;
  });

  if (isRunningLocally()) {
    envs.push(LOCAL_ENV);
  }

  const registryEnv = activeEnvs.find((env) => env.name === "registry");
  if (registryEnv) {
    envs.push(registryEnv);
  }

  const stagingEnv = activeEnvs.find((env) => env.name === "STAGING");
  if (stagingEnv) {
    envs.push(stagingEnv);
  }

  const prodEnv = activeEnvs.find((env) => env.name === "PROD");
  if (prodEnv) {
    envs.push(prodEnv);
  }

  const defaultEnv = activeEnvs.find((env) => env.isDefault);
  if (defaultEnv) {
    envs.push(defaultEnv);
  }

  const podEnvs = activeEnvs
    .filter((env) => env.name.includes("-pod-"))
    .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));

  const devEnvs = activeEnvs
    .filter((env) => env.name.includes("development") && !env.name.includes("-pod-"))
    .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));

  return Array.from(new Set([...envs, ...podEnvs, ...devEnvs, ...activeEnvs]));
};
